import { Outlet } from 'react-router-dom';

import { FiltersPanel } from './index';

export const FiltersPanelLayout = (): JSX.Element => (
    <>
        <FiltersPanel />
        <Outlet />
    </>
);
